
import React, { Component } from 'react'
import './differentiator.scss'
import Button from '@material-ui/core/Button';
const jsdiff = require('diff');
class Differentiator extends Component {
    constructor(props) {
        super(props);
        this.state = { json: {}, fileName: '', fileName1: '', json1: {}, showOption: '' };
        this.fileInput = React.createRef()
        this.fileInput1 = React.createRef()
    }
    render () {
        const diff = jsdiff.diffJson(this.state.json, this.state.json1);
        const result = Object.keys(this.state.json).length === 0 ? <h3>Please upload some file having JSON data.</h3>
            : diff.map((part, index) => {
                var spanStyle = {
                    backgroundColor: part.added ? 'lightgreen' : part.removed ? 'salmon' : 'white'
                };
                return (
                    <>

                        <span key={index} style={spanStyle}>{part.value}</span>

                    </>
                )
            });

        const uploadFile = async (e) => {
            e.preventDefault()

            const reader = new FileReader()
            const fileName = e.target.files[0].name
            reader.onload = async (e) => {
                const text = (e.target.result)

                this.setState({ json: text, fileName: fileName })
            };
            reader.readAsText(e.target.files[0])
        }

        const uploadFile1 = async (e) => {
            e.preventDefault()
            const fileName = e.target.files[0].name
            const reader = new FileReader()
            reader.onload = async (e) => {
                const text = (e.target.result)
                this.setState({ json1: text, fileName1: fileName })
            };
            reader.readAsText(e.target.files[0])
        }

        const changeShowOption = (option) => {
            this.setState({ showOption: option })
        }

        return (
            <div className="differentiator">
                <div className="differentiator__left">
                    <div className="differentiator__button">
                        <label htmlFor="upload-photo">
                            <input
                                style={{ display: 'none' }}
                                id="upload-photo"
                                name="upload-photo"
                                type="file"
                                ref={this.fileInput}
                                onChange={(e) => uploadFile(e)} />

                            <Button
                                style={{ background: '#a0148c', color: 'white', height: '20px' }}
                                variant="contained"
                                component="span">
                                Upload File 1
                        </Button>
                        </label>

                        <label htmlFor="upload-photo-1">
                            <input
                                style={{ display: 'none' }}
                                id="upload-photo-1"
                                name="upload-photo-1"
                                type="file"
                                ref={this.fileInput1}
                                onChange={(e) => uploadFile1(e)} />

                            <Button
                                style={{ background: '#a0148c', color: 'white', height: '20px' }}
                                variant="contained"
                                component="span">
                                Upload File 2
                        </Button>
                        </label>
                    </div>




                    <div >
                        <span>
                            <pre>
                                <code >
                                    {result}
                                </code>
                            </pre>
                        </span>
                    </div>
                </div>

                <div className="differentiator__right">
                    <div className="differentiator__label">
                        <h3>Click file name to view file</h3>
                    </div>

                    <div className="differentiator__label">

                        {
                            this.state.fileName !== '' &&
                            <Button onClick={(() => changeShowOption('json'))}> {this.state.fileName} </Button>
                        }

                        {
                            this.state.fileName1 !== '' &&

                            <Button onClick={(() => changeShowOption('json1'))}> {this.state.fileName1} </Button>
                        }
                    </div>

                    <div>
                        <span>
                            <pre>
                                <code >
                                    {
                                        this.state.showOption === 'json' &&
                                        <div>

                                            <pre>{this.state.json}</pre>

                                        </div>
                                    }

                                    {
                                        this.state.showOption === 'json1' &&
                                        <div >
                                            <pre>{this.state.json1}</pre>
                                        </div>

                                    }
                                </code>
                            </pre>
                        </span>
                    </div>
                </div>
            </div >
        )
    }
}

export default Differentiator;